import { useSpinDelay } from "spin-delay";

type SpinDelayOptions = Parameters<typeof useSpinDelay>[1];

export function useLoadingDelay(isLoading: boolean, options?: SpinDelayOptions): boolean {
  return useSpinDelay(isLoading, { delay: 0, minDuration: 300, ...options });
}
